module.exports = __webpack_public_path__ + "img/react-js.b53f1cf5.svg";